import {
  ValidationError,
  EValidationSeverity,
} from 'components/ui/excel-table/types';
import { TFunction } from 'i18next';
import { isNil } from 'lodash';
import { DeclarationData } from 'components/features/binding/contract-detail/declaration-detail';
import { ContractResponseDtoContractStatusEnum } from 'libs/pinnacle-sdk';

export const validateDeclarationDetails =
  (
    layerPremium: number,
    contractStatus?: ContractResponseDtoContractStatusEnum
  ) =>
  (
    row: DeclarationData,
    rowIndex: number,
    allRows: DeclarationData[],
    t: TFunction
  ) => {
    const errors: ValidationError<DeclarationData>[] = [];

    if (isNil(row.declarationName) || row.declarationName.trim() === '') {
      errors.push({
        field: 'declarationName',
        message: t('validation.required', {
          field: t('contractDetail.declarationDetail.declarationName'),
        }),
        rowIndex,
      });
    }

    if (isNil(row.entityName) || row.entityName.trim() === '') {
      errors.push({
        field: 'entityName',
        message: t('validation.required', {
          field: t('contractDetail.declarationDetail.entityName'),
        }),
        rowIndex,
      });
    }

    if (isNil(row.country) || row.country.trim() === '') {
      errors.push({
        field: 'country',
        message: t('validation.required', {
          field: t('contractDetail.declarationDetail.country'),
        }),
        rowIndex,
      });
    }

    if (isNil(row.programOrder)) {
      errors.push({
        field: 'programOrder',
        message: t('validation.required', {
          field: t('contractDetail.declarationDetail.programOrder'),
        }),
        rowIndex,
      });
    } else if (row.programOrder > 100) {
      errors.push({
        field: 'programOrder',
        message: t('validation.max', {
          max: 100,
          field: t('contractDetail.declarationDetail.programOrder'),
        }),
        rowIndex,
      });
    } else if (row.programOrder <= 0) {
      errors.push({
        field: 'programOrder',
        message: t('validation.min', {
          min: 0,
          field: t('contractDetail.declarationDetail.programOrder'),
        }),
        rowIndex,
      });
    }

    if (
      isNil(row.programOrderTotalPremium) ||
      Number(row.programOrderTotalPremium) <= 0
    ) {
      errors.push({
        field: 'programOrderTotalPremium',
        message: t('validation.min', {
          min: 0,
          field: t('contractDetail.declarationDetail.programOrderTotalPremium'),
        }),
        rowIndex,
      });
    }

    // Validate total programOrderTotalPremium equals layerPremium
    // Skip validation if contract is already bound
    if (contractStatus !== ContractResponseDtoContractStatusEnum.Bound) {
      const totalPremium = allRows.reduce((sum, item) => {
        return sum + (Number(item.programOrderTotalPremium) || 0);
      }, 0);

      if (
        Number(row.programOrderTotalPremium) > 0 &&
        Math.abs(totalPremium - layerPremium) > 0.01
      ) {
        // Allow small rounding difference
        errors.push({
          field: 'programOrderTotalPremium',
          message: t(
            'contractDetail.declarationDetail.declarationTotalPremiumMismatch',
            {
              field: t(
                'contractDetail.declarationDetail.programOrderTotalPremium'
              ),
              total: totalPremium.toFixed(2),
              expected: layerPremium.toFixed(2),
              layerPremium: t('contractDetail.layerPremium'),
            }
          ),
          rowIndex,
          severity: EValidationSeverity.STRICT,
        });
      }
    }

    return errors;
  };
